import axios, {AxiosResponse} from "axios";
import {
    PAYMENTS_INVOICE_PRICES_ENDPOINT,
    PAYMENTS_INVOICE_ENDPOINT,
    INVOICE_ENDPOINT, BILL_ENDPOINT
} from "@/constants/endpoints.ts"
import authHeader from "@/services/auth-header";
import {WorkspaceType} from "@/dto/auth/Workspace";
import QueryUtils from "@/utils/QueryUtils";
import Page from "@/dto/taxation/Page";
import InvoiceDTO, {InvoiceItem} from "@/dto/InvoiceDTO";
import {ServiceSet} from "@/dto/payment/ServiceSet";
import PriceOptionDTO from "@/dto/payment/price/PriceOptionDTO";
import CreateInvoicePayload from "@/dto/CreateInvoicePayload";
import {ServiceInvoice, ServiceInvoiceFilter, Summary} from "@/components/payroll/business/services/ServiceDTO";
import {Vue} from "vue-property-decorator";

class InvoiceService {

    createCustomInvoice(payload: CreateInvoicePayload) {

        return axios.post(`${PAYMENTS_INVOICE_ENDPOINT}`, payload, {headers: authHeader()})
    }

    createInvoiceFromPriceOption(payload: CreateInvoicePayload) {

        return axios.post(`${PAYMENTS_INVOICE_ENDPOINT}`, payload, {headers: authHeader()})
    }

    getInvoicesPage(payerId: number, payerType: WorkspaceType, pageNumber = 1, pageSize = 20) {
        const queryString = QueryUtils.buildQueryString(
            ["pageNumber", pageNumber],
            ["pageSize", pageSize],
            ["payerId", payerId],
            ["payerType", payerType]
        )
        return axios.get<Page<InvoiceDTO<InvoiceItem>>>(`${PAYMENTS_INVOICE_ENDPOINT}${queryString}`, {headers:authHeader()});
    }
    getPriceList(){
        return axios.get<Record<ServiceSet, Array<PriceOptionDTO>>>(`${PAYMENTS_INVOICE_PRICES_ENDPOINT}`, {headers:authHeader()});
    }

    public getPageByFilter(filter: ServiceInvoiceFilter) {
        const query = QueryUtils.objectToQueryString(filter);
        return axios.get<Page<ServiceInvoice>>(`${INVOICE_ENDPOINT}${query}`, {headers: authHeader()})
    }

    public getAllByFilter(filter: ServiceInvoiceFilter) {
        const query = QueryUtils.objectToQueryString(filter);
        return axios.get<Array<ServiceInvoice>>(`${INVOICE_ENDPOINT}/all${query}`, {headers: authHeader()})
    }

    public getInvoiceSummary(payeeId = Vue.prototype.$wss.getCurrent.id) {
        return axios.get<Summary>(`${INVOICE_ENDPOINT}/summary/${payeeId}`, {headers: authHeader()})
    }

    public getBillSummary(payerId = Vue.prototype.$wss.getCurrent.id) {
        return axios.get<Summary>(`${BILL_ENDPOINT}/summary/${payerId}`, {headers: authHeader()})
    }

    public complete(invoiceId: number): Promise<AxiosResponse<InvoiceDTO<InvoiceItem>>> {
        return axios.put<InvoiceDTO<InvoiceItem>>(`${INVOICE_ENDPOINT}/${invoiceId}/complete`, {}, {headers: authHeader()})
    }

    public decline(invoiceId: number): Promise<AxiosResponse<InvoiceDTO<InvoiceItem>>> {
        return axios.put<InvoiceDTO<InvoiceItem>>(`${INVOICE_ENDPOINT}/${invoiceId}/decline`, {}, {headers: authHeader()})
    }



}

export default new InvoiceService();